import './styles/bootstrap.css';
import './scss/style.scss';
import "bootstrap/dist/js/bootstrap.min.js";
import LayoutNavigation from './navigation/LayoutNavigation';


function App() {
  return (
    <div className="App">
      <LayoutNavigation />
    </div>
  );
}

export default App;
